import React from 'react';
import { Button, Modal } from 'antd';
import {
  ButtonGroup,
  FooterModal,
  TitleStyle,
} from 'components/AntModalTitleFile/styled';
import { ExclamationCircleFilled } from '@ant-design/icons';
import useMultiLanguageRegisterCompany from 'page/Application/ManageCompanyList/RegisterCompany/hook/useMultiLanguageRegisterCompany';

const AntModalTitleFile = ({
  isModalOpen,
  handleOk,
  handleCancel,
  loadingSubmit,
  title,
  content,
  width,
  paddingRight,
  isDisabled,
}) => {
  const { REGISTER_COMPANY_SAVE, REGISTER_COMPANY_CANCEL } =
    useMultiLanguageRegisterCompany();

  return (
    <Modal
      forceRender
      title={<TitleStyle>{title ?? 'Basic Modal'}</TitleStyle>}
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      centered={true}
      maskClosable={false}
      width={width ?? 430}
      style={{ padding: '80px 0' }}
      closable={!isDisabled}
      icon={<ExclamationCircleFilled />}
      footer={[
        <FooterModal key="footerModal">
          <ButtonGroup style={{ paddingRight: paddingRight }}>
            <Button
              key="submit"
              type="primary"
              loading={loadingSubmit}
              onClick={handleOk}
              style={{ minWidth: '78px', lineHeight: 1.5 }}
              disabled={isDisabled}
            >
              <span> {REGISTER_COMPANY_SAVE}</span>
            </Button>
            <Button
              key="back"
              onClick={handleCancel}
              style={{
                marginLeft: '12px',
                width: '128px',
                background: 'white',
                color: '#656464',
                lineHeight: 1.5
              }}
              disabled={isDisabled}
            >
              <span> {REGISTER_COMPANY_CANCEL}</span>
            </Button>
          </ButtonGroup>
        </FooterModal>,
      ]}
    >
      {content}
    </Modal>
  );
};
export default AntModalTitleFile;
